import request from '@/utils/request'

export function getPermissionSodRiskOverview () {
  return request({
    url: '/addon/permissionSodRisk/overview',
    method: 'get'
  })
}
